import React, { Component } from "react";
import Loading from '../../hoc/Loading/Loading';
import * as actionCreators from '../../modules/actions/index';
import { connect } from 'react-redux';
import axios from '../../axios';
import {withRouter} from 'react-router-dom';
import './Events.css';
import * as url from '../../utils/url';
import {displayEventDates, grpEventImg, is_event_past} from '../../utils/constants';
import moment from 'moment';
import AddToEvent from "../AddToEvent/AddToEvent";

class EventListItem extends Component {

    constructor(props) {
        super(props);    
        this.state = {
          going_count:null,
          interested_count: null
        };
      }

      componentDidMount(){
        let{item}=this.props
        this.setState({
          going_count: item.eventId.going_count,
          interested_count: item.eventId.interested_count
        })
      }

      goToEventPage=event=>{
        // toolkitCategories
        this.props.history.push(`/home/toolkit/conferences-events/tool/${event._id}`)
      }


      renderEventDate =(eventId)=>{
        let res;
        if(eventId.startDate && eventId.endDate){
          let{startDate,endDate}=eventId
          let isSameYear = moment(startDate).format('YYYY')==moment(endDate).format('YYYY')
          if(isSameYear){
            let isSameDay = moment(startDate).isSame(moment(endDate), 'day')
            if(isSameDay){
              res = `${moment(startDate).format('ddd, MMM Do h:mm a')} - ${moment(endDate).format('h:mm a')}`
            }else{
              res = `${moment(startDate).format('ddd, MMM Do')} - ${moment(endDate).format('ddd, MMM Do')}`
            }
          } else {
            res = `${moment(startDate).format('ddd, MMM Do YYYY')} - ${moment(endDate).format('ddd, MMM Do YYYY')}`
          }
        } else if(eventId.startDate && !eventId.endDate){
          let{startDate}=eventId
          res = `${moment(startDate).format('ddd, MMM Do YYYY') }`
        } 
        return res
      }



      changeEventStatus=update=>{
        if(update){
          this.setState({
            going_count: update.going_count,
            interested_count: update.interested_count
          })
        }
      }


  render() {
    let { eventId  } = this.props.item
    let item = this.props.item
    let{interested_count, going_count}=this.state

      let{bannerImg, image}=eventId
      let bg_image = bannerImg!=null&&bannerImg.url?bannerImg.url: image && image!=null?image: grpEventImg
      let event_is_past = !is_event_past(eventId)

      return (
        // group_list_items_container
        // is_event_past
              <div className={`card user_profile_events_list ${event_is_past? 'event_is_past':''}`}>
                <div className='user_profile_events_list_img_container cursor-pointer' onClick={()=> this.goToEventPage(eventId)}>
                  <img src={bg_image} />
                </div>
                  <div className="card-body">
                    
                    <span 
                    onClick={()=> this.goToEventPage(eventId)} 
                    className="user_profile_events_card_body_container cursor-pointer">
                        <span className="event_list_page_item_date txtOverflow">  
                          {/* {this.renderEventDate(eventId)} */}
                          {displayEventDates(eventId)}
                        {/* {moment(startDate).format('dddd, MMMM Do YYYY, h:mm a')} - {moment(endDate).format('dddd, MMMM Do YYYY, h:mm a')} */}
                        </span>


                        <span className="event_list_page_item_title">{eventId.name}</span>


                        <span className="event_list_page_item_details txtOverflow fw800 txt_sz_8r"> 
                          {eventId.subCategory?eventId.subCategory:''} 
                        </span>

                        {item.invitedBy && item.invitedBy?
                        <span className="event_list_page_item_details txtOverflow">  
                          invited by {item.invitedBy.firstName} {item.invitedBy.lastName}
                        </span> : null }

                        <span className="event_list_page_item_details txtOverflow"> 
                          {interested_count} interested · {going_count} going
                        </span>
                    </span>

                    {!event_is_past?
                    <span className="event_list_page_item_details"> 
                      {/* created on {moment(item.createDate).format('MMM Do, YYYY')}   */}
                      {item && item._id?
                      <AddToEvent
                      mod_height={'35px'}
                      isParentType={3}
                      changeEventStatus={this.changeEventStatus}
                      item={item}
                      disable={true}
                      curr_rsvp={item.rsvp}
                       />
                       :null}
                    </span>
                    :null}

                   {event_is_past? <span className="profile_page_event_items_is_past"> 
                        Event ended
                    </span>:null}
                    {/* <Modal isOpen={showManualEntryAnswersModal}>
                      <ManualEntryModal
                        questionAnswer={kpiData}
                        clickedPoint={clickedPoint}
                        toggle={() => {this.setState((p) => ({showManualEntryAnswersModal 
                          : !p.showManualEntryAnswersModal}))}}
                      />
                    </Modal> */}
                  </div>
                </div>
              
        );
    
  }
}



const mapStateToProps = state => {
    return {
      user: state.user,
      objectives: state.enterpriseObjective.objectives
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onFetchEnterpriseObjectives: (data) => dispatch(actionCreators.storeEnterpriseObjectives(data)),
      orgChangeSuccess: (data)=> dispatch(actionCreators.orgChangeSuccess(data)),
      resetObjective : () => dispatch(actionCreators.resetEnterpriseObjectives())
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(EventListItem, axios)));